import React from "react";
import { NavLink } from "react-router-dom";
import "../../styles/sidebar.css";

const Sidebar = () => {
  return (
    <div className="sidebar1">
      <NavLink to="/admin/dashboard" className="sidebar-link" activeClassName="active-link">
        Dashboard
      </NavLink>

      <NavLink to="/admin/departments" className="sidebar-link" activeClassName="active-link">
        Departments
      </NavLink>
      <NavLink to="/admin/gallery" className="sidebar-link" activeClassName="active-link">
        Gallery
      </NavLink>
      <NavLink to="/admin/placements" className="sidebar-link" activeClassName="active-link">
        Placements
      </NavLink>
      <NavLink to="/admin/manageplacement" className="sidebar-link" activeClassName="active-link">
        Placements Manager
      </NavLink>
      <NavLink to="/admin/publication" className="sidebar-link" activeClassName="active-link">
        Publications
      </NavLink>
     
      <NavLink to="/admin/news" className="sidebar-link" activeClassName="active-link">
        News & Events
      </NavLink>
      <NavLink to="/admin/administration" className="sidebar-link" activeClassName="active-link">
        Administration
      </NavLink>
      <NavLink to="/admin/169placement" className="sidebar-link" activeClassName="active-link">
        Placement169
      </NavLink>
      
      <NavLink to="/admin/signup" className="sidebar-link" activeClassName="active-link">
        Add Admin
      </NavLink>

      <NavLink to="/admin" className="sidebar-link" activeClassName="active-link">
        Logout
      </NavLink>
    </div>
  );
};

export default Sidebar;